import type { ChecklistItem } from '../../types';

export function isEssentialsComplete(concert: { status?: string }): boolean {
  return concert.status === 'done';
}

export function isNegotiatedComplete(concert: {
  total_amount?: string;
  benefits?: string;
  times?: string;
  duration?: string;
  backline?: string;
  technique?: string;
}): boolean {
  return !!(
    concert.total_amount?.trim() &&
    concert.benefits?.trim() &&
    concert.times?.trim() &&
    concert.duration?.trim() &&
    concert.backline?.trim() &&
    concert.technique?.trim()
  );
}

export function isChecklistComplete(checklist: ChecklistItem[]): boolean {
  return checklist.length > 0 && checklist.every((item) => item.done);
}
